import React, { useContext } from 'react'
import { MainContext } from '../../context/Main.context';
import { Tab } from '../Tab/Tab';
import { ButtonChoice, ButtonChoiceWrapper } from '../Tab/Tab.styled';

export const MutationTab = () => {
    const { 
        currentFormTab,
        mutation,
        setMutation,
    } = useContext(MainContext);
    
    return (
        <Tab show={currentFormTab === 5}>
            <h2>S'agit-t-il d'une mutation ?</h2>
            <ButtonChoiceWrapper>
                <ButtonChoice
                    isActive={mutation}
                    type="button"
                    onClick={() => {
                        setMutation(true);
                    }}
                >
                    Oui
                </ButtonChoice>
                <ButtonChoice
                    isActive={!mutation}
                    type="button"
                    onClick={() => setMutation(false)}
                >
                    Non
                </ButtonChoice>
            </ButtonChoiceWrapper>
        </Tab>
    )
}
